// https://stackoverflow.com/a/9310752
export function escapeRegExpSpecialCharacter(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
